import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../pages/Home.module.css";
import { createApiUrl } from "../utils/apiConfig";
import { restrictedVideoProps } from "../utils/restrictedVideo";

const VideoSection = ({ videoName }) => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Fallback video URLs for common scenarios
  const getFallbackVideoUrl = () => {
    if (process.env.NODE_ENV === 'production') {
      return null; 
    } else {
      return null;
    }
  };

  useEffect(() => {
    const fetchWebData = async () => {
      try {
        const res = await axios.get(createApiUrl("/api/webdata"));
        return res.data;
      } catch (err) {
        setError(`Failed to fetch video data: ${err.message}`);
        return null;
      }
    };

    const loadVideo = async () => {
      setLoading(true);
      setError(null);
      
      const webDataResponse = await fetchWebData();
      const webData = webDataResponse?.webData || [];
      
      
      const videoData = webData.find(
        (item) => item.video && item.video.name === videoName
      );
      
      
      if (videoData) {
        setVideoUrl(videoData.video.url);
      } else {
        // Try fallback URL if available
        const fallbackUrl = getFallbackVideoUrl();
        if (fallbackUrl) {
          setVideoUrl(fallbackUrl);
        } else {
          setError(`Video "${videoName}" not found in database. Please check if the video has been uploaded to the admin panel.`);
        }
      }
      
      setLoading(false);
    };
    
    loadVideo();
  }, [videoName]);

  return (
    <div className={`${styles['video-section']} text-center`}>
      {loading ? (
        <div style={{ padding: '20px', color: '#666' }}>
          <p>Loading video...</p>
        </div>
      ) : error ? (
        <div style={{ padding: '20px', color: '#d32f2f', border: '1px solid #d32f2f', borderRadius: '8px', backgroundColor: '#ffebee' }}>
          <p><strong>Video Error:</strong></p>
          <p>{error}</p>
        </div>
      ) : videoUrl ? (
        <video
          controls
          {...restrictedVideoProps}
          preload="auto"
          autoPlay
          muted
          className={`${styles['video-element']} video-element`}
          onError={(_e) => {
            setError('Video failed to load. Please check the video URL.');
          }}
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      ) : (
        <div style={{ padding: '20px', color: '#666' }}>
          <p>No video available</p>
        </div>
      )}
    </div>
  );
};

export default VideoSection; 
